import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header/header';
import './deletionofemp.css'; // You can use this for styles

const DeleteOfEmployee = () => {
    const [employees, setEmployees] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await fetch('/api/employees');
            const data = await res.json();
            // Show only inactive employees
            const inactiveEmployees = data.filter(emp => emp.status === 'Inactive');
            setEmployees(inactiveEmployees);
        } catch (error) {
            console.error('Error fetching employees:', error);
        }
    };

    const handleDisable = async (id) => {
        try {
            const res = await fetch(`/api/employees/${id}/disable`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ status: 'Inactive' }),
            });

            if (res.ok) {
                const updatedEmployees = employees.map(emp =>
                    emp.id === id ? { ...emp, status: 'Inactive' } : emp
                );
                setEmployees(updatedEmployees);
            } else {
                console.error('Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
        }
    };

    const filteredEmployees = employees.filter(emp =>
        emp.fullName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
        <div>
                <Header />
        </div>
        <div className="delete-container">
            <div className="left-panel-search">
                <input
                    type="text"
                    placeholder="Search by Full Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-bar-delete"
                />
            </div>

            <div className="table-container">
                <table className="employee-table">
                    <thead style={{ backgroundColor: '#3656AF', color: '#fff' }}>
                            <tr>
                                <th>SL No.</th>
                                <th>EmpID</th>
                                <th>Full Name</th>
                                <th>Date of Joining</th>
                                <th>Emp_Designation</th>
                                <th>Phone No.</th>
                                <th>Gender</th>
                                <th>Age</th>
                                <th>Relationship</th>
                                <th>Sum Insured</th>
                                <th>Company</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredEmployees.map((emp, index) => (
                                <tr key={emp.id}>
                                    <td>{index + 1}</td>
                                    <td>{emp.empid}</td>
                                    <td>{emp.fullName}</td>
                                    <td>{emp.joiningDate}</td>
                                    <td>{emp.designation}</td>
                                    <td>{emp.phone}</td>
                                    <td>{emp.gender}</td>
                                    <td>{emp.age}</td>
                                    <td>{emp.relationship}</td>
                                    <td>{emp.sumInsured}</td>
                                    <td>{emp.Company}</td>
                                    <td>{emp.status}</td>
                                </tr>
                            ))}
                       
                    </tbody>
                </table>
            </div>
        </div>
        </div>
    );
};

export default DeleteOfEmployee;
